import { FC, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { Loader } from '@/shared_elements';
import { campaignController } from '@/apis/core';
import { RCS_CAMPAIGN_ENABLED } from '@/constants';
import { ROUTES } from '@/constants/paths';

interface LocationState {
  goBackPage?: string;
}

interface CampaignRedirectorParams {
  id: string;
}

const CampaignRedirector: FC<CampaignRedirectorParams> = () => {
  const history = useHistory();
  const { state } = useLocation<LocationState>();
  const { id } = useParams<CampaignRedirectorParams>();

  const redirect = async () => {
    if (id) {
      if (!RCS_CAMPAIGN_ENABLED) {
        history.replace(
          ROUTES.TEN_DLC_CAMPAIGN_DETAILS.replace(':id', id),
          state
        );
        return;
      }
      const campaign = await campaignController.getCampaign(id);
      if (campaign) {
        history.replace(
          (campaign.channelId === 'RCS'
            ? ROUTES.RCS_CAMPAIGN_DETAILS
            : ROUTES.TEN_DLC_CAMPAIGN_DETAILS
          ).replace(':id', id),
          state
        );
      }
    }
  };

  useEffect(() => {
    redirect();
  }, [id]);

  return <Loader />;
};

export default CampaignRedirector;
